
























import Vue from 'vue'
import { gaEventTracker, EVENT_CATEGORIES } from '@/common/utils'
import { ProductState } from '@/product/types'
import { scrollToElement } from '@/helper'
import LocalStorageSerializer from '@/common/localStorageSerializer'
import { LOCAL_STORAGE_KEY } from '@/product/const'

export default Vue.extend({
  props: {
    analyticsValue: {
      type: String,
      default: ''
    },
    eventAction: {
      type: String,
      default: ''
    },
    eventLabel: {
      type: String,
      default: ''
    }
  },
  computed: {
    storeState(): ProductState {
      return this.$store.state
    },
    editorUrl(): string {
      const selectedPrefectureId = LocalStorageSerializer.get(
              LOCAL_STORAGE_KEY.PRODUCT_DETAIL_PREFECTURE
            )?.id || ''
      const urlParams = new URLSearchParams({
        psi: this.storeState.productDetail.printableSkuId,
        addonPsi: this.$store.getters.addonProductPsi || this.storeState.addonProduct?.selectedAddonProductId || '',
        designVersion: this.storeState.stockLibraryDesign.userDesignVersionUuid || '',
        prefectureId: selectedPrefectureId,
        optionIds: this.storeState.selectedAdditionalOptionIds.join(',')
      }).toString()
      return `/editor?${urlParams}&quantities=${this.$store.getters.sizeInputQuery}`
    },
    disableLink(): boolean {
      return !this.$store.getters.isSimplifiedSendable
    },
    invalidActionProcess(): boolean {
      return (
        !this.$store.getters.validQuantity ||
        this.$store.getters.invalidProductSetSelection ||
        this.$store.getters.invalidPrintingSelection
      )
    },
    eventCategory() {
      return EVENT_CATEGORIES.PRODUCT_DETAIL
    },
    unpublished(): boolean {
      return this.$store.getters.isProductUnpublished
    }
  },
  methods: {
    onProceeding(e: Event) {
      if (this.invalidActionProcess) {
        e.preventDefault()
        this.$store.dispatch('showSizeInputWarning')
        this.$store.dispatch('showAddonWarning')
        this.$store.dispatch('showPrintingOptionsWarning')
        this.$store.dispatch('trackingError', 'Editor')
        this.$nextTick(() => scrollToElement('[class*="pr-InvalidOrderProcess"]'))
      }
      gaEventTracker(
        this.eventCategory,
        this.eventAction,
        this.eventLabel
      )
    }
  }
})
